class giftCardModal extends HTMLElement {
  constructor() {
    super();
    this.giftCardBtn = document.querySelector('.gift-card-button');
    this.iconClose = this.querySelector('.icon-close');
    this.selectedAmount = this.querySelector('.gift-card-modal__selected-amount');
    this.giftCardModalAddToCart = this.querySelector('.gift-card-modal-add-to-cart');
    
    // Open
    this.giftCardBtn.addEventListener('click', this.onGiftCardBtnClick.bind(this));

    // Close
    this.iconClose.addEventListener('click', this.closeGiftCardModal.bind(this));
    this.addEventListener('click', function(e) {if (e.target === this) this.closeGiftCardModal()});
    window.addEventListener('keydown', e => {if (e.key === 'Escape') this.closeGiftCardModal()});

    // Add to cart
    this.giftCardModalAddToCart.addEventListener('click', this.giftCardAddToCart.bind(this));
  }

  onGiftCardBtnClick(e) {
    const selectedAmount = document.querySelector('.product-form').querySelector('[name="Amount"]:checked').value;

    e.preventDefault();

    // 1. Selected amount
    this.selectedAmount.textContent = selectedAmount;

    // 2. Open gift card modal
    this.openGiftCardModal();
  }

  openGiftCardModal() {
    this.classList.remove('hidden');
    document.body.classList.add('gift-card-modal-opened');
  }

  closeGiftCardModal() {
    this.classList.add('hidden');
    document.body.classList.remove('gift-card-modal-opened');
  }

  giftCardAddToCart(e) {
    const form = this.querySelector('.gift-card-modal__form');

    e.preventDefault();

    if (form.checkValidity()) {
      // 1. Get values from the modal form
      const name = this.querySelector('#gift-card-modal-name').value;
      const email = this.querySelector('#gift-card-modal-email').value;
      const date = this.querySelector('#gift-card-modal-date').value;
      const message = this.querySelector('#gift-card-modal-message').value;

      // 2. Set values to the main product form
      document.querySelector('#gift-card-recipient-name').value = name;
      document.querySelector('#gift-card-recipient-email').value = email;
      document.querySelector('#gift-card-send-on').value = date;
      document.querySelector('#gift-card-message').value = message;

      // 3. Close the modal
      this.closeGiftCardModal();

      // 4. Add to cart
      document.querySelector('.add-to-cart-button').click();
    } else {
      form.reportValidity();
    }
  }
}

customElements.define('gift-card-modal', giftCardModal);